<div class="row">
    <div class="col-xs-12 col-md-6 col-lg-3">
        <h3>In Behandlung</h3>
        <openconsultlist></openconsultlist>
    </div>

    <div class="col-xs-12 col-md-6 col-lg-3">
        <h3>Wartelisten</h3>
        <div class="alert alert-info">Derzeit keine Patienten auf der Warteliste</div>
        <!--<waitinglists></waitinglists>-->
    </div>
    <div class="col-xs-12 col-md-6 col-lg-3">
        <allreminders></allreminders>
    </div>
    <div class="col-xs-12 col-md-6 col-lg-3">
        <todowidget></todowidget>
        <chat></chat>
    </div>

</div>